export const industryConstants = {
    GET_INDUSTRIES_SUCCESS:  'GET_INDUSTRY_SUCCESS',
    SHOW_INDUSTRY_SUCCESS: 'SHOW_INDUSTRY_SUCCESS',
    UPDATE_INDUSTRY_SUCCESS: 'UPDATE_INDUSTRY_SUCCESS',
    ADD_INDUSTRY_SUCCESS: 'ADD_INDUSTRY_SUCCESS',
    REMOVE_INDUSTRY_SUCCESS: 'REMOVE_INDUSTRY_SUCCESS',
    STORE_INDUSTRY_SUCCESS: 'STORE_INDUSTRY_SUCCESS',
};
